<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row class="mb-3">
        <v-col cols="12" sm="12" md="8">
          <GradeClassStudentSelect
            :gradeCol="{ cols: 12, md: 6 }"
            :classCol="{ cols: 12, md: 6 }"
            disableStudentSelect
            @changed="gradeClassChange"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="4">
          <v-text-field
            v-model="studentCode"
            clear-icon="mdi-close"
            label="Mã học viên"
            flat
            outlined
            dense
            clearable
            hide-details
            @keyup.enter="onFilterChanged"
          />
        </v-col>
        <v-col cols="12" sm="12" md="4">
          <v-text-field
            v-model="studentName"
            label="Tên học viên"
            return-object
            clearable
            flat
            outlined
            dense
            hide-details
            @keyup.enter="onFilterChanged"
          />
        </v-col>
        <v-col cols="12" sm="12" md="4">
          <v-select
            v-model="selectedStatus"
            :items="studentStatus"
            clear-icon="mdi-close"
            item-text="title"
            item-value="status"
            label="Trạng thái"
            dense
            outlined
            clearable
            hide-details
          />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import get from 'lodash-es/get'
import { textHelpers } from '@/helpers/TextHelper'
import utils from '@/plugins/utils'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'

export default {
  components: {
    GradeClassStudentSelect,
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    studentCode: '',
    studentName: '',
    selectedStatus: '',
  }),
  created() {
    // Default active
    this.selectedStatus = this.studentStatus[0].status
  },
  computed: {
    ...mapState('constant', ['studentStatus']),
  },
  methods: {
    onFilterChanged() {
      const studentQueryParams = {}
      const queryCode = textHelpers.removeSpaces(this.studentCode)
      const queryName = textHelpers.removeSpaces(utils.clearUnicode(this.studentName))
      if (get(this.selectedClass, 'id', '')) {
        studentQueryParams.classes = get(this.selectedClass, 'id', '')
      } else {
        if (get(this.selectedGrade, 'id', '')) {
          studentQueryParams.grade = get(this.selectedGrade, 'id', '')
        }
      }
      if (queryCode) {
        studentQueryParams.code_contains = queryCode
      }
      if (queryName) {
        studentQueryParams.tags_contains = queryName
      }
      if (this.selectedStatus) {
        studentQueryParams.status = this.selectedStatus
      }
      this.$emit('onFilterChanged', studentQueryParams)
    },
    gradeClassChange(data) {
      this.selectedGrade = data.grade
      this.selectedClass = data.class
    },
  },
  watch: {},
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
